if (!customElements.get('product-delivery-date')) {
  customElements.define(
    'product-delivery-date',
    class ProductDeliveryDate extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-delivery-date-input]');
        this.error = this.querySelector('[data-delivery-date-error]');

        if (!this.input || this.input.dataset.initialized === 'true') return;

        this.input.dataset.initialized = 'true';
        this.minimumDate = this.getMinimumDate();
        this.input.min = this.minimumDate;

        this.input.addEventListener('input', () => this.validate());
        this.input.addEventListener('blur', () => this.validate());
        this.input.addEventListener('invalid', () => this.validate(true));
      }

      getMinimumDate() {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Monterrey',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).formatToParts(new Date());
        const dateParts = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
        const minimum = new Date(Date.UTC(Number(dateParts.year), Number(dateParts.month) - 1, Number(dateParts.day)));

        minimum.setUTCDate(minimum.getUTCDate() + 1);
        if (minimum.getUTCDay() === 0) minimum.setUTCDate(minimum.getUTCDate() + 1);

        return minimum.toISOString().slice(0, 10);
      }

      validate(showRequiredError = false) {
        let message = '';

        if (!this.input.value) {
          if (showRequiredError) message = 'Selecciona una fecha de entrega para continuar.';
        } else {
          const [year, month, day] = this.input.value.split('-').map(Number);
          const selectedDate = new Date(Date.UTC(year, month - 1, day));

          if (this.input.value < this.minimumDate) {
            message = 'Selecciona una fecha disponible a partir de mañana.';
          } else if (selectedDate.getUTCDay() === 0) {
            message = 'No entregamos los domingos. Elige otro día.';
          }
        }

        this.input.setCustomValidity(message);
        this.input.toggleAttribute('aria-invalid', Boolean(message));
        this.error.textContent = message;
        this.error.hidden = !message;

        return !message;
      }
    }
  );
}
